'use client'

import { useEffect, useMemo, useRef } from 'react'

import { TRoomsEvent, TRoomsSearchParams } from '@/entities/room'
import { useAirbridgeContext } from '@/shared/config'

import { buildSearchSemanticAttributes } from './search-event'

type Props = {
  airbridgeEvent: TRoomsEvent | null
  filters: TRoomsSearchParams
}

export const AirbridgeEventSender = ({ airbridgeEvent, filters }: Props) => {
  const { sendEvent, isInitialized } = useAirbridgeContext()
  const sentIdRef = useRef<string>('')

  const semanticAttributes = useMemo(
    () => buildSearchSemanticAttributes(filters),
    [
      filters.additionalOptions,
      filters.basicOptions,
      filters.popularOptions,
      filters.propertyTypes,
      filters.pyeongSizes,
      filters.roomCounts,
      filters.roomDiscounts,
    ],
  )

  const isKeywordPresent = !!filters.keyword
  const isFiltersApplied =
    filters.roomCounts.length > 0 ||
    filters.propertyTypes.length > 0 ||
    filters.pyeongSizes.length > 0 ||
    filters.popularOptions.length > 0 ||
    filters.basicOptions.length > 0 ||
    filters.additionalOptions.length > 0 ||
    filters.roomDiscounts.length > 0

  useEffect(() => {
    if (!airbridgeEvent || (!isKeywordPresent && !isFiltersApplied)) {
      return
    }

    const eventKey = `${airbridgeEvent.action} ${airbridgeEvent.label} ${JSON.stringify(semanticAttributes)}`

    // initialized 되지 않았거나 strict mode 중복인 경우 return
    if (!isInitialized || sentIdRef.current === eventKey) {
      return
    }

    sentIdRef.current = eventKey

    sendEvent({
      event: airbridgeEvent.eventName,
      params: {
        action: airbridgeEvent.action,
        label: airbridgeEvent.label,
        value: airbridgeEvent.value,
        semanticAttributes,
      },
    })
  }, [
    airbridgeEvent,
    semanticAttributes,
    isKeywordPresent,
    isFiltersApplied,
    isInitialized,
    sendEvent,
  ])

  return null
}
